class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener("mouseover", this.onHover.bind(this));
    this.mainDetailsToggle.addEventListener("mouseout", this.offHover.bind(this));
  }

  onHover() {
    if (this.mainDetailsToggle.hasAttribute("open")) return;
    this.mainDetailsToggle.setAttribute("open", "");
  }

  offHover() {
    if (!this.mainDetailsToggle.hasAttribute("open")) return;
    this.mainDetailsToggle.removeAttribute("open");
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
      super();
      this.header = document.querySelector(".header-wrapper");
      
      this.initializeImageAndContentOnHover();
  }

  initializeImageAndContentOnHover() {
      const categoryLinks = this.querySelectorAll('.mega-menu__navigation-categories__item');
      const categoryContents = document.querySelectorAll('.mega-menu__navigation-categories__item-content');
      const promotions = this.querySelectorAll('.mega-menu__promotion');

      categoryLinks.forEach((category, index) => {
          category.addEventListener('mouseover', (event) => {
            event.preventDefault();
            
            // Handle promotion images
            promotions.forEach(promo => promo.style.display = 'none'); 
            if (promotions[index]) {
                promotions[index].style.display = 'block';
            }
            
            // Handle content
            categoryContents.forEach(content => content.style.display = 'none');
            categoryContents[index].style.display = 'block';
          });
      });
  }

  

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);